import { GUI } from "lil-gui";

const _instance = new GUI()
export default _instance